import React from 'react'

class PageButton extends React.Component {
    render() {

        let className = 'page-item d-none d-lg-inline';
        if (this.props.pageNumber===this.props.currentPage) {
          className += ' active';
        }

        return (
            <li className={className}>
                <button style={{"width":"45px"}} onClick={() => this.props.gotoPage(this.props.pageNumber)} className="page-link">
                    {this.props.pageNumber + 1}
                </button>
            </li>
        );
    }
}

export default PageButton